import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@shared/typography/title';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { UserFormView } from '@app/feature/user/generic-user/user-form/user-form.view';
import { Snackbar } from '@shared/snackbar/snackbar';
import { useUpdateOperatorMutation } from '@service/operator.service';
import { BackOfficeUserModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/back-office-user.model';
import { UpdateOperatorModel } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/models/users/update-user.model';

interface OperatorUpdateProps {
  operator: BackOfficeUserModel;
  onCancel: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function OperatorUpdate({
  operator,
  onCancel,
  onError,
  onSuccess,
}: OperatorUpdateProps): React.JSX.Element {
  const { t } = useTranslation();

  const [handleUpdateOperator, { isLoading, isError, error }] =
    useUpdateOperatorMutation();

  const handleSubmit = (updatedOperator: UpdateOperatorModel) => {
    if (!operator.id) {
      onError();
      return;
    }

    handleUpdateOperator({
      id: operator.id,
      ...updatedOperator,
    })
      .unwrap()
      .then(() => {
        onSuccess();
      });
  };

  return (
    <>
      <DialogTitle icon={<EditOutlinedIcon />}>
        {t('user.operator.update.title')}
      </DialogTitle>

      <UserFormView
        defaultValues={operator}
        formType="update"
        onSubmit={handleSubmit}
        pending={isLoading}
        onCancel={onCancel}
      />

      {isError && (
        <Snackbar
          variant="error"
          message={t('error.patch-user-mutation', { error })}
        />
      )}
    </>
  );
}
